import * as React from 'react';
import {Button} from "antd";
import usePortalService from '../../services/PortalService';
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { ReactionResolveOption } from "../../Enums/ReactionResolveOption";
import { ReactionFilterOption } from "../../Enums/ReactionFilterOption";
import { ReactionResolve } from '../../types';
import { StyledModal } from './StyledModal';

export const ApplyReaction = ({isOpen, close, reactionId, setStatus}: ReactionResolve) => {
  	const { resolveToReaction } = usePortalService();
  	const [message, setMessage] = useState('');

  	const applyHandler = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLElement, MouseEvent>) => {
    	e.stopPropagation();
    	const result = await resolveToReaction({
			reactionId,
			reactionResolveOption: ReactionResolveOption.Invite,
			message
    	})
		if (result.success) {
			setStatus(ReactionFilterOption.InvitationReactions)
			close();
		}
	};

	return(
		<StyledModal 
			title="Пригласить кандидата" 
			open={isOpen}
			footer={[
				<Button onClick={close} key="back" style={{marginRight: '6px'}}>Отмена</Button>,
				<Button type="primary" key="submit" onClick={e => applyHandler(e)}>Пригласить</Button>
			]}
			onCancel={close}
		>
			<p> Текст сообщения </p>
			<TextArea rows={12} value={message} onChange={e => setMessage(e.target.value)}/>
		</StyledModal>
	)
}